<template>
  <component
    :is="iconComponent"
    role="img"
    :class="iconClass"
    :width="iconWidth"
    :height="iconHeight"
    v-on="listeners"
  />
</template>

<script>
import BSvgCircleHelp from './svg/circle-help.vue'
import icons from './svg/index.js'
import { pascalCase } from 'change-case'

const iconRotates = [0, 90, 180, 270]

const iconName = (name) => {
  const pascalCaseName = pascalCase(typeof name === 'string' ? name : '')
    .replace(/-/g, '')

  return `BSvg${pascalCaseName}`
}

export const iconNameValidator = (value) => {
  return Object.prototype.hasOwnProperty.call(icons, iconName(value))
}

export default {
  name: 'b-svg',
  props: {
    name: {
      type: String,
      required: true,
      validator: iconNameValidator,
    },
    size: {
      type: [String, Number],
      default: 24,
    },
    width: {
      type: [String, Number],
    },
    height: {
      type: [String, Number],
    },
    color: {
      type: String,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    rotate: {
      type: String,
      validator: (value) => iconRotates.includes(+value),
    },
  },
  components: {
    BSvgCircleHelp,
  },
  computed: {
    listeners () {
      return {
        click: () => { this.$emit('click') },
      }
    },
    iconComponent () {
      return icons[iconName(this.name)]
    },
    iconWidth () {
      return this.width || this.size
    },
    iconHeight () {
      return this.height || this.size
    },
    iconClass () {
      return {
        'b-svg': true,
        [`b-svg-name-${this.name}`]: true,
        'b-icon-inline': !!this.inline,
        [`b-text-${this.color}`]: !!this.color,
        [`b-icon-rotate-${this.rotate}`]: !!this.rotate,
      }
    },
  },
}
</script>
